import React, { Component } from 'react';
import {Modal, Button, Tab, Icon} from 'semantic-ui-react';

import PrintSTS from './PrintSTS';
import ListBP from './ListBP';

export default class ModalDetail extends Component {

   constructor(props){
      super(props);
      this.state = {
         data:props.data_detail,
      }
   }

   render() {
      const { data } = this.state
      const panes = [
         { menuItem: 'Detail STS',
           render: () => <Tab.Pane attached={false}>
             <PrintSTS data_detail={data} />
           </Tab.Pane>
         },
         { menuItem: 'Detail BP',
           render: () => <Tab.Pane attached={false}>
             <ListBP data_detail={data} />
           </Tab.Pane>
         },
       ]

      return (
         <div>
            {
            data===null ? null:
               <div>
                  <style>
                     {`@media print {
                        .table-footer tr td {
                           font-size: 8pt;
                           padding: 0px;
                           text-align: left;
                        }

                        .txt-left{
                           text-align: left;
                           padding: 0px;
                        }
                        
                     }`}
                  </style>

                  <Modal trigger={<Button>Show Modal</Button>} closeIcon
                     open={this.props.open}
                     onClose={this.props.onClose}
                     closeOnEscape={false}
                     closeOnRootNodeClick={false}
                     size="fullscreen"
                  >
                     <Modal.Header>
                        Detail Surat Tanda Setoran (STS) [{data.no_sts}]
                     </Modal.Header>

                     <Modal.Content scrolling>
                        <Tab menu={{ pointing: true }} panes={panes} /><br/>
                     </Modal.Content>
                     <Modal.Actions>
                        <Button style={{'float': 'left'}} negative onClick={this.props.onClose}>Tutup</Button>
                        <Button negative onClick={this.props.onClose}>Tutup</Button>
                     </Modal.Actions>
                  </Modal>
            </div> }
      </div>
      );
   }
}



// WEBPACK FOOTER //
// ./src/components/Content/views/opd/_sts/ModalDetail.js